import { useCallback, useEffect, useRef } from 'react'
import { connectSearchBox } from 'react-instantsearch-dom'
import { SearchInput } from 'components/SearchInput/SearchInput'
import { Icon } from 'blaze-ui/icons/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const Input = ({
  value,
  setValue,
  refine,
  placeholder,
  hideIcon = false,
  keepIconInMobile = false,
  icon,
}: {
  value: string
  setValue: (s: string) => void
  refine: (s: string) => void
  placeholder: string
  hideIcon?: boolean
  keepIconInMobile?: boolean
  icon?: Icon
}) => {
  const { isMobile } = useResponsiveDesign()
  const inputRef = useRef<HTMLInputElement>(null)
  const DebounceInterval = 0

  useEffect(() => {
    setTimeout(() => {
      if (isMobile) inputRef.current?.focus()
    }, 250)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onChange = useCallback(
    (value: any) => {
      setValue(value)
      refine(value)
    },
    [refine, setValue],
  )

  return (
    <SearchInput
      ref={inputRef}
      autoFocus={!isMobile}
      placeholder={placeholder}
      onChange={onChange}
      debounceInterval={DebounceInterval}
      size={'lg'}
      icon={icon}
      hideIcon={hideIcon}
      keepIconInMobile={keepIconInMobile}
    />
  )
}

export const CustomSearchInput: React.ComponentClass<any> = connectSearchBox(Input)
